import React from "react";
import FooterComponent from "../WebSite/Footer/FooterComponent";
import HeaderComponent from "../WebSite/Header/HeaderComponent";
import DigitalTrust from "../../../src/images/aboutImg/closeup-shot-beekeeper-holding-honeycombs-frame-with-many-bees-making-honey.jpg";
import Trading from "../../../src/images/aboutImg/care-services.jpg";
import Blockchain from "../../../src/images/aboutImg/business-success-concept-wooden-table-top-view-hands-protecting-wooden-figures-people (1).jpg";
import Farming from "../../../src/images/aboutImg/shot-beekeeper-beekeeping-suit-standing-near-row-beehives-his-apiary-copyspace.jpg";
import CareImg from "../../../src/images/aboutImg/full-length-view-beekeeper-working-landscapes-with-confident-expression-agrarian-natural-summer-honeycombs-concept.jpg";
import "react-awesome-slider/dist/styles.css";
import AboutBanner from "./AboutBanner";
import AboutSubSection from "../aboutSubSection/AboutSubSection";

// Exporting the AboutusComponent functional component
export default function AboutusComponent() {
  return (
    <>
      {/* Header section */}
      <HeaderComponent />

      {/* About Us Banner */}
      <AboutBanner />

      {/* Main About Us content wrapper */}
      <div className="about-main-wrapper">

        {/* Subsection 1: Why We Exist */}
        <AboutSubSection
          className="rowReverseAbout"
          description="We exist to amplify farmers' yields by 50%, driving agricultural prosperity and food security."
          title="Why We Exist"
          src={Farming}
        />

        {/* Subsection 2: Who We Are */}
        <AboutSubSection
          className1="aboutBgGrey"
          className="rowReverseAbout--mod"
          description="We are a technology-enabled agri-healthcare company dedicated to revolutionizing agriculture through innovative solutions."
          title="Who We Are"
          src={DigitalTrust}
        />

        {/* Subsection 3: Whom We Care About */}
        <AboutSubSection
          className="rowReverseAbout"
          description="We prioritize the well-being and success of farmers and agri-input retailers, ensuring their needs are at the heart of everything we do."
          title="Whom We Care About"
          src={CareImg}
        />

        {/* Subsection 4: What We Do */}
        <AboutSubSection
          className1="aboutBgGrey"
          className="rowReverseAbout--mod"
          description="We facilitate accessible care services for both plants and animals, simplifying agricultural management and enhancing productivity for farmers."
          title="What We Do"
          src={Trading}
        />

        {/* Subsection 5: How We Do It */}
        <AboutSubSection
          className="rowReverseAbout"
          description="We own and manage Agri Retailer Network as part of Community Based Network (CBN) in rural areas for the approved input retailers. Through this network we empower input retailers to serve the farmers."
          title="How We Do It"
          src={Blockchain}
        />
      </div>

      {/* Footer section */}
      <FooterComponent />
    </>
  );
}

